export default {
  scheduled: 'scheduled',
  processing: 'processing',
  success: 'success',
  error: 'error',
  deleted: 'deleted',
};
